export const replaceFieldsWithValues = (
    inputString: string,
    dataValues: any,
    stringifyValue?: boolean
): string => {
    const pattern = /{{(.*?)}}/g;

    let replacingString = '';

    replacingString = inputString?.replace(pattern, (match, fieldName) => {
        const multipleValue = fieldName.split(',');
        const trimmedFieldName = multipleValue[0].trim();

        const keys = trimmedFieldName
            .split('.')
            .map((key: any) => key.replace(/\[([^\]]+)\]/g, '.$1').trim());
        let value = dataValues;

        for (const key of keys) {
            if (value && value.hasOwnProperty(key)) {
                value = value[key];
            } else {
                value = key;
            }
        }

        if (stringifyValue) {
            value = JSON.stringify(value);
        }

        if (multipleValue[1]) {
            switch (multipleValue[1]) {
                case 'color':
                    value = `<span style="color: ${multipleValue[2]}">${value}</span>`;
                    break;
                default:
                    break;
            }
        }

        return value;
    });

    return replacingString;
};
